// Loading skeleton components — CSS animate-pulse only, no extra dependencies

export function DealCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm w-full overflow-hidden animate-pulse">
      {/* Foto-placeholder zelfde hoogte als echte DealCard foto */}
      <div className="aspect-[4/3] w-full bg-gray-200" />
      <div className="p-5 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <div className="h-5 bg-gray-200 rounded w-2/3" />
          <div className="h-5 bg-gray-200 rounded-full w-14 shrink-0" />
        </div>
        <div className="flex items-baseline gap-2">
          <div className="h-8 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-200 rounded w-12" />
          <div className="h-4 bg-gray-200 rounded w-16" />
        </div>
        <div className="flex items-center gap-2">
          <div className="h-4 bg-gray-200 rounded w-24" />
          <div className="h-4 bg-gray-200 rounded-full w-14" />
        </div>
        <div className="h-9 bg-gray-200 rounded-xl w-full" />
      </div>
    </div>
  )
}

export function DealsListSkeleton({ count = 8 }) {
  return (
    <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }, (_, i) => (
        <li key={i}>
          <DealCardSkeleton />
        </li>
      ))}
    </ul>
  )
}
